// Set elements we want to target
const targets_children = [
	".wp-block-columns",
	".wp-block-gallery",
	".wp-block-media-text:not([class*='is-style'])",
	".wp-block-table table tbody",
];
const targets_self = [
	// ".wp-block-image",
	// ".wp-block-video",
	// ".wp-block-embed",
	".wp-block-media-text[class*='is-style']",
	".wp-block-media-text[class*='is-style'] > .wp-block-media-text__content",
	".wp-block-cover > .wp-block-cover__inner-container",
	// ".wp-block-group > *:not(:has([data-reveal])",
	// ":where(main, .single-content, .wp-block-group) > *:not(:has([data-reveal])",
];

function sectionRevealAnimations() {
	// Do nothing if IntersectionObserver isn't supported
	if (!("IntersectionObserver" in window)) {
		console.log("IntersectionObserver is not supported");
		return false;
	}
	// Do nothing if browser is set to reduced motion
	if (!window.matchMedia("(prefers-reduced-motion: no-preference)")) {
		console.log("browser either doesn't support prefers-reduced-motion or is set to prefers-reduced-motion: reduced");
		return false;
	}

	// Add data-reveal attributes to elements defined above
	var elements_children = document.querySelectorAll(targets_children.join(", "));
	elements_children.forEach(function (element) {
		element.setAttribute("data-reveal", "children");
	});
	var elements_self = document.querySelectorAll(targets_self.join(", "));
	elements_self.forEach(function (element) {
		element.setAttribute("data-reveal", "self");
	});

	const observerThreshold = 0;

	// Set up observer
	var sectionObserver = new IntersectionObserver(
		function (entries, observer) {
			entries.forEach(function (entry) {
				if (entry.isIntersecting || entry.boundingClientRect.y < 0) {
					entry.target.setAttribute("data-reveal-state", "visible");
					observer.unobserve(entry.target);
				} else if (!entry.target.hasAttribute("data-reveal-state")) {
					entry.target.setAttribute("data-reveal-state", "watching");
				}
			});
		},
		{ threshold: observerThreshold }
	);

	// Activate observer
	var sections = document.querySelectorAll("[data-reveal]");
	sections.forEach(function (element) {
		// element.setAttribute("data-reveal-state", "watching");
		let bounding = element.getBoundingClientRect();

		if (
			bounding.top <= (window.innerHeight || document.documentElement.clientHeight) &&
			bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight)
		) {
		} else {
			// console.log(element);
			// console.log(bounding);
			sectionObserver.observe(element);
		}
	});
}
document.addEventListener("DOMContentLoaded", function () {
	sectionRevealAnimations();
});
